var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "SidebarShell",
    {
      attrs: { collapsed: _vm.isCollapsed, mobile: _vm.mobile, open: _vm.open },
      on: {
        toggle: function($event) {
          return _vm.$emit("toggle")
        }
      },
      scopedSlots: _vm._u([
        {
          key: "brand",
          fn: function() {
            return [
              _c(
                "div",
                {
                  staticClass: "gestao-brand",
                  class: {
                    "gestao-brand--collapsed": _vm.isCollapsed,
                    "gestao-brand--image":
                      _vm.showLogoImage || _vm.showFaviconImage
                  }
                },
                [
                  _vm.showLogoImage
                    ? _c("img", {
                        staticClass:
                          "gestao-brand__image gestao-brand__image--logo",
                        attrs: { src: _vm.logoEscritorio, alt: _vm.officeName },
                        on: { error: _vm.onLogoError }
                      })
                    : _vm.showFaviconImage
                    ? _c("img", {
                        staticClass:
                          "gestao-brand__image gestao-brand__image--favicon",
                        attrs: {
                          src: _vm.faviconEscritorio,
                          alt: _vm.officeName
                        },
                        on: { error: _vm.onFaviconError }
                      })
                    : [
                        _c("div", { staticClass: "gestao-brand__logo" }, [
                          _vm._v(_vm._s(_vm.officeInitial))
                        ]),
                        !_vm.isCollapsed
                          ? _c("div", { staticClass: "gestao-brand__info" }, [
                              _c("div", { staticClass: "gestao-brand__name" }, [
                                _vm._v(_vm._s(_vm.officeName))
                              ])
                            ])
                          : _vm._e()
                      ]
                ],
                2
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("div", { staticClass: "gestao-sidebar__root" }, [
        _c(
          "div",
          { staticClass: "gestao-sidebar__top" },
          [
            _vm.homeRow
              ? _c("NavItem", {
                  attrs: {
                    item: _vm.homeRow.item,
                    collapsed: _vm.isCollapsed,
                    active: _vm.homeRow.active
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("select", _vm.homeRow.item)
                    }
                  }
                })
              : _vm._e(),
            _vm._l(_vm.topItemRows, function(row) {
              return _c("NavItem", {
                key: row.item.key,
                attrs: {
                  item: row.item,
                  collapsed: _vm.isCollapsed,
                  active: row.active
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("select", row.item)
                  }
                }
              })
            })
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "gestao-sidebar__partes" },
          [
            _vm.showPartes
              ? _vm._l(_vm.parteRows, function(row) {
                  return _c(
                    "NavParte",
                    {
                      key: row.key,
                      ref: "partes",
                      refInFor: true,
                      attrs: {
                        parte: row,
                        open: row.open,
                        active: row.active,
                        collapsed: _vm.isCollapsed,
                        mobile: _vm.mobile,
                        subitems: row.subitems
                      },
                      on: {
                        toggle: _vm.toggleParte,
                        "hover-subitems": _vm.openFlyout,
                        "leave-subitems": _vm.scheduleClose
                      }
                    },
                    _vm._l(row.items, function(cell) {
                      return _c("NavItem", {
                        key: cell.item.key,
                        attrs: {
                          item: cell.item,
                          subitems: cell.item.subitems,
                          collapsed: _vm.isCollapsed,
                          mobile: _vm.mobile,
                          active: cell.active
                        },
                        on: {
                          click: function($event) {
                            return _vm.$emit("select", cell.item)
                          },
                          "hover-subitems": _vm.openFlyout,
                          "leave-subitems": _vm.scheduleClose
                        }
                      })
                    }),
                    1
                  )
                })
              : _vm._l(_vm.mainSectionRows, function(secao) {
                  return _c(
                    "div",
                    { key: secao.key, staticClass: "gestao-sidebar__secao" },
                    [
                      secao.title && !_vm.isCollapsed
                        ? _c(
                            "div",
                            { staticClass: "gestao-sidebar__secao-titulo" },
                            [_vm._v(" " + _vm._s(secao.title) + " ")]
                          )
                        : _vm._e(),
                      _vm._l(secao.rows, function(row) {
                        return [
                          _c("NavItem", {
                            key: row.item.key,
                            attrs: {
                              item: row.item,
                              subitems: row.subitems,
                              collapsed: _vm.isCollapsed,
                              mobile: _vm.mobile,
                              active: row.active
                            },
                            on: {
                              click: function($event) {
                                return _vm.$emit("select", row.item)
                              },
                              "hover-subitems": _vm.openFlyout,
                              "leave-subitems": _vm.scheduleClose
                            }
                          }),
                          row.inlineSubitems.length
                            ? _c(
                                "div",
                                {
                                  key: row.item.key + "-inline",
                                  staticClass: "gestao-sidebar__inline-subitems"
                                },
                                _vm._l(row.inlineSubitems, function(cell) {
                                  return _c("NavItem", {
                                    key: cell.item.key,
                                    attrs: {
                                      item: cell.item,
                                      collapsed: _vm.isCollapsed,
                                      active: cell.active
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.$emit("select", cell.item)
                                      }
                                    }
                                  })
                                }),
                                1
                              )
                            : _vm._e()
                        ]
                      })
                    ],
                    2
                  )
                })
          ],
          2
        ),
        _vm.configItemRows.length
          ? _c(
              "div",
              { staticClass: "gestao-sidebar__config" },
              _vm._l(_vm.configItemRows, function(row) {
                return _c("NavItem", {
                  key: row.item.key,
                  attrs: {
                    item: row.item,
                    subitems: row.item.subitems,
                    collapsed: _vm.isCollapsed,
                    mobile: _vm.mobile,
                    active: row.active
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("select", row.item)
                    },
                    "hover-subitems": _vm.openFlyout,
                    "leave-subitems": _vm.scheduleClose
                  }
                })
              }),
              1
            )
          : _vm._e()
      ]),
      _c(
        "transition",
        { attrs: { name: "flyout" } },
        [
          _vm.flyout
            ? _c("NavFlyout", {
                attrs: {
                  title: _vm.flyout.item.label,
                  items: _vm.flyout.item.subitems,
                  "anchor-top": _vm.flyout.top,
                  "anchor-left": _vm.flyout.left,
                  "active-route-name": _vm.activeRouteName,
                  "match-by": _vm.flyout.matchBy
                },
                on: {
                  select: _vm.onSelectSubitem,
                  mouseenter: _vm.cancelClose,
                  mouseleave: _vm.scheduleClose
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }